import { ENV } from "shared-tsi";
export const environment = {
    production: false,
    name: ENV.DEV,
    apiService_Auth: '/backend-login',
    apiService_Erp: '/backend-erp',
    apiService_Report: '/backend-report',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_FE: '/backend-fe',
    apiService_Notificaciones: '/backend-notification',
    recaptcha: {
        siteKey: '6LdqZT0sAAAAAHAFBX8eo0fXQKCHYhd9C6IoY7UZ',
    },
    URL_CONFIGURACION: 'url_configuracion',
    PRODUCTO: 'REPUESTOS'

};
